import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import DynamicHeader from "../Header/DynamicHeader";

// Dummy data (replace with API data as needed)
const initialNotifications = [
  {
    id: 1,
    user: "Aa",
    message: "Meg Griffin has left you a review. Both of your reviews from this trip are now public.",
    date: "March 1, 2025",
  },
  {
    id: 2,
    user: "Aa",
    message: "Cleveland Brown has left you a review. Both of your reviews from this trip are now public.",
    date: "February 26, 2025",
  },
  {
    id: 3,
    user: "Aa",
    message: "Glenn accepted your invite to co-host Cheerful 2-bedroom home in the heart of Quahog",
    date: "April 25, 2025",
  },
  {
    id: 4,
    user: "Aa",
    message: "Glenn accepted your invite to co-host Cozy 3BR home minutes from downtown Quahog",
    date: "March 6, 2025",
  },
  {
    id: 5,
    user: "Aa",
    message: "Please confirm your email address by clicking on the link we just emailed you. If you cannot find the email, you can request a new confirmation email or change your email address.",
    date: "March 1, 2025",
  },
];

const Notification = () => {
  const [notifications, setNotifications] = useState(initialNotifications);

  // Remove notification on "X"
  const handleRemove = (id) => {
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  return (
    <div className="noti-bg">
      <DynamicHeader/>
      <div className="noti-container">
        <h2 className="noti-title">Notifications</h2>
        <div className="noti-list">
          {notifications.length === 0 ? (
            <div className="noti-empty">No notifications</div>
          ) : (
            notifications.map((n) => (
              <div className="noti-row" key={n.id}>
                <div className="noti-avatar">{n.user}</div>
                <div className="noti-content">
                  <div className="noti-message">{n.message}</div>
                  <div className="noti-date">{n.date}</div>
                </div>
                <button className="noti-close" onClick={() => handleRemove(n.id)} aria-label="Dismiss">
                  <FiX size={22} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
      <style>{`
        .noti-bg {
          min-height: 100vh;
          // background: #111015 url('/bg-dark.svg') center/cover no-repeat; /* adjust if you have a background */
          padding: 0;
        }
        .noti-container {
          max-width: 750px;
          margin: 0 auto;
          padding: 36px 18px 0 18px;
        }
        .noti-title {
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 36px;
        }
        .noti-list {
          width: 100%;
        }
        .noti-row {
          display: flex;
          align-items: flex-start;
          // background: rgba(30,27,40,0.96);
          // border-radius: 12px;
          margin-bottom: 16px;
          box-shadow: 0 1px 0 0 #222022;
          padding: 18px 14px 18px 12px;
          position: relative;
        }
        .noti-avatar {
          background: #e7685c;
          color: #fff;
          font-weight: 700;
          font-size: 1.2rem;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 18px;
          margin-top: 2px;
          flex-shrink: 0;
        }
        .noti-content {
          flex: 1 1 0%;
          min-width: 0;
        }
        .noti-message {
          color: #fff;
          font-size: 1.04rem;
          font-weight: 500;
          margin-bottom: 8px;
          line-height: 1.35;
        }
        .noti-date {
          color: #c7c1dc;
          font-size: 0.92rem;
          margin-bottom: 0;
        }
        .noti-close {
          background: none;
          border: none;
          color: #bbb;
          cursor: pointer;
          padding: 0 3px;
          margin-left: 12px;
          font-size: 1.5rem;
          margin-top: 2px;
          transition: color 0.16s;
        }
        .noti-close:hover {
          color: #ff5e5e;
        }
        .noti-empty {
          text-align: center;
          color: #c7c1dc;
          font-size: 1.1rem;
          margin-top: 80px;
        }
        @media (max-width: 600px) {
          .noti-container { padding: 26px 3vw 0 3vw; }
          .noti-row { padding: 12px 8px 12px 7px; }
          .noti-title { font-size: 1.15rem; }
          .noti-message { font-size: 0.96rem; }
          .noti-avatar { width: 34px; height: 34px; font-size: 0.99rem; }
        }
      `}</style>
    </div>
  );
};

export default Notification;
